/**
 * Provides an interface for modifying a `Document` that is associated with a file (as opposed to one associated with a directory).
 * @module app/views/Documents/FileEditView
 */
import Backbone from "backbone";
import _ from "underscore";
import UrlBuilder from "@HBKEngineering/url-builder";
var FileEditView = Backbone.View.extend({
  className: "form file-edit",

  tagName: "form",

  attributes: {
    enctype: "multipart/form-data",
    method: "post",
  },

  _checkUri: function () {
    this.getUrlControl().parent().children("span").remove();

    if (!this.isFileType()) {
      if (UrlBuilder.isUri(this.getUrlControl().val())) {
        this.getUrlControl().parent().removeClass("has-error");
      } else {
        this.getUrlControl().parent().addClass("has-error");
        this.getUrlControl()
          .parent()
          .append('<span class="help-block">That is not a valid URL.</span>');
      }
    }
  },

  events: {
    "change .dir-type": function () {
      if (!this.isFileType()) {
        this.getUrlControl().parent().show();

        this.getFileControl().parent().hide();
      } else {
        this.getUrlControl().parent().hide();
        this.getFileControl().parent().show();
      }
    },
    "change .uri": "_checkUri",
    "keyup .uri": "_checkUri",
  },

  template: _.template(
    '<div class="form-group"><label class="control-label" for="dir-name">Name</label><input type="text" value="<%= model.attributes.Name %>" id="dir-name" name="dir-name" class="dir-name form-control"/></div><div class="form-group"><label class="control-label" for="dir-type">Entry Type</label><select name="dir-type" class="form-control dir-type"><option value="file">File</option><option value="link">Link</option></select></div><div class="form-group"><label class="control-label" for="uri">Link URL</label><input type="url" name="uri" class="form-control uri" value="<%= model.attributes.Uri %>"/></div><div class="form-group"><label class="control-label" for="file">File</label><input type="file" name="file" class="form-control file"/></div>'
  ),

  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {Document} options.model The model to update.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options);
  },

  render: function () {
    this.$el.html(this.template(this.options));

    if (UrlBuilder.isUri(this.options.model.get("Uri"))) {
      this.$(".dir-type").val("link").change();
    } else {
      this.$(".dir-type").val("file").change();
    }

    return this;
  },

  /**
   * Commit the changes to the model.
   */
  commit: function () {
    var filename = this.getFileControl().val();

    filename = filename.replace(/^.*(\\|\/|:)/, "");

    this.options.model.set(
      "Name",
      this.$(".dir-name").val() || filename || "file"
    );

    if (!this.isFileType()) {
      this.options.model.set("Uri", this.getUrlControl().val());
    }
  },

  /**
   * Get a reference to the file tag associated with this view.
   * @return {jquery} The file tag.
   */
  getFileControl: function () {
    return this.$(".file");
  },

  /**
   * Get a reference to the URL tag associated with this view.
   * @return {jquery} The URL tag.
   */
  getUrlControl: function () {
    return this.$(".uri");
  },

  /**
   * Gets a value indicating whether or not the user has elected to create a file document (vs a URL document)
   * @return {Boolean} True if the user is creating a file, otherwise false.
   */
  isFileType: function () {
    return this.$(".dir-type").val() == "file";
  },
});

export default FileEditView;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/documents/FileEditView.js
// module id = 895
// module chunks = 1